import {lazy} from "react";
import {Route} from "react-router";
import Error from "@/components/error/error.tsx";

const SettingsCategoryMyAccount = lazy(
    () => import("./features/settings-categories/settings-category-my-account/settings-category-my-account.tsx")
);
const SettingsCategoryPayment = lazy(
    () => import("./features/settings-categories/settings-category-payment/settings-category-payment.tsx")
);
const SettingsCategoryNotifications = lazy(
    () => import("./features/settings-categories/settings-category-notifications/settings-category-notifications.tsx")
);
const SettingsCategoryPersonalData = lazy(
    () => import("./features/settings-categories/settings-category-personal-data/settings-category-personal-data.tsx")
);
const SettingsCategoryAddresses = lazy(
    () => import("./features/settings-categories/settings-category-addresses/settings-category-addresses.tsx")
);

const SettingsRoutes= [
    <Route path="settings-my-account" element={<SettingsCategoryMyAccount />} errorElement={<Error/>} />,
    <Route path="settings-personal-data" element={<SettingsCategoryPersonalData />} errorElement={<Error/>} />,
    <Route path="settings-addresses" element={<SettingsCategoryAddresses />} errorElement={<Error/>} />,
    <Route path="settings-payment" element={<SettingsCategoryPayment />} errorElement={<Error/>} />,
    <Route path="settings-notifications" element={<SettingsCategoryNotifications />} errorElement={<Error/>} />
];
export default SettingsRoutes;
